import { render, staticRenderFns } from "./ProjectSettingsCorporateIdentity.vue?vue&type=template&id=67f9ef80&scoped=true"
import script from "./ProjectSettingsCorporateIdentity.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsCorporateIdentity.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingsCorporateIdentity.vue?vue&type=style&index=0&id=67f9ef80&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f9ef80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f9ef80')) {
      api.createRecord('67f9ef80', component.options)
    } else {
      api.reload('67f9ef80', component.options)
    }
    module.hot.accept("./ProjectSettingsCorporateIdentity.vue?vue&type=template&id=67f9ef80&scoped=true", function () {
      api.rerender('67f9ef80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/projects/ProjectSettingsCorporateIdentity.vue"
export default component.exports